import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * 404 also covers "exists, but not for you": the API 404s a document outside the
 * caller's sections rather than admitting it exists (docs/03 §4), so the copy has to
 * cover both without implying the record is there.
 */
export const NotFoundPage = () => {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-20 text-center">
      <div className="flex size-11 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <FileQuestion className="size-5" />
      </div>
      <div className="space-y-1">
        <p className="font-medium">{t('errors.notFound')}</p>
        <p className="max-w-md text-sm text-muted-foreground">{t('errors.notFoundBody')}</p>
      </div>
      <Button asChild variant="outline" size="sm">
        <Link to="/">{t('actions.back')}</Link>
      </Button>
    </div>
  );
};

export default NotFoundPage;
